import ListSoldProductsByLocationTable from './ListSoldProductsByLocationTable';

export default ListSoldProductsByLocationTable;
